import { TrackOrderType } from './types'
import client from '../../client'

export const getTrackOrder = (orderId: string) =>
  client.get<TrackOrderType>(`v1/order-track/${orderId}`)
